<template>
    <Button :label="$t('accept_order')" icon="pi pi-plus" class="p-button-success p-button-sm mr-1" @click="onAction(true)"/>

    <Button :label="$t('reject_order')" icon="pi pi-times" class="p-button-danger p-button-sm mr-1"  @click="onAction(false)"/>

    <BlockUI :blocked="blocked">
        <Dialog v-model:visible="showTransporterActionModal" :closeOnEscape="false" :closable="false" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
            <template #header>
                <h4>{{isAccept ? $t('accept_order') : $t('reject_order')}}</h4>
            </template>

            {{isAccept ? $t('message.transporter_action_confirmation_accept') : $t('message.transporter_action_confirmation_reject') }}

            <div v-if="!processed">
                <div v-for="item in pData" v-bind:key="item.Id">
                    <div class="grid">
                        <div class="col-5">
                            {{item.SAP_No}} / {{item.Order_No}}
                        </div>
                        <div class="col-6">
                            
                            <div class="p-fluid">
                                <InputText type="text" class="p-inputtext-sm" v-model="item.Dispatch_Status_Remarks"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="item in resultData" v-bind:key="item.ref_no">
                    <div class="grid">
                        <div class="col-5">
                            {{item.ref_no}}
                        </div>
                        <div class="col-6">
                            <div class="p-fluid">
                                <InputText type="text" class="p-inputtext-sm" v-model="item.reason" :disabled="true" />
                            </div>
                        </div>
                        <div class="col-1">
                            <div v-if="item.success">
                                <Tag class="mr-2" :severity="isAccept ? 'success' : 'danger'" :value="isAccept ? 'Accepted' : 'Rejected'"></Tag>
                            </div>
                            <div v-else>
                                <Tag class="mr-2" severity="danger" :value="item.message"></Tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div v-if="processing" style="float:right">
                    <ProgressSpinner style="width:50px;height:50px"/>
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button :label="$t('no')" icon="pi pi-times" class="p-button-text" @click="onClose"/>
                        <Button :label="$t('yes')" icon="pi pi-check" autofocus @click="onConfirmAction"/>
                    </div>
                    <div v-else>
                        <Button :label="$t('close')" icon="pi pi-times" class="p-button-text" @click="onClose"/>
                    </div>
                    
                </div>
                
            </template>
        </Dialog>
    </BlockUI>
</template>

<script>
export default ({
    props:{
        pData: {
            type: Array,
            default: null
        },
    },
    emits: ['close'],
    data(){
        return{
            showTransporterActionModal: false,
            dataUrl: "order/",
            blocked:false,
            headerTitle: "",
            isAccept: false,
            isReject: false,
            rejectReason: "",
            processed: false,
            processing: true,
            resultData: null
        }
    },
    mounted(){
      
    },
    methods:{
        onAction(isAccept){
            this.showTransporterActionModal = true;
            this.isAccept = isAccept;
            this.isReject = !isAccept;
            this.processed = false;
            this.processing = false;
        },
        onConfirmAction(){
            var self = this;

            var process = true;
            for(var x = 0; x < this.processData.length;x++){
                var procData = this.processData[x];

                if(!procData.reason && this.isReject){
                    this.$toast.add({ severity: 'error', summary: "Error", detail: procData.ref_no + ": " + this.$t('alert.require_reason'), life: 120000});
                    process = false;
                    return;
                }
            }

            if(!process) return;

            this.processing = true;
            var process = true;

            this.$axios.post(this.$API_URL + this.dataUrl + "transporter_action", this.processData)
                .then((response) => {
                    if(response.data){
                        self.resultData = response.data.data;
                        self.processed = true;
                        self.processing = false;
                    }
                    else{

                    }
                })
                .catch(function (err) {
                    console.log(err);
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                    self.blocked = false;

                    self.processed = true;
                    self.processing = false;
                    //self.showAssignModal = false;
                });
        },
        onClose(){
            if(!this.processing){
                this.processed = false;
                this.showTransporterActionModal = false;
                this.$emit("close");
            }
            
        }
    },
    computed:{
        processData(){
            var h = [];

            for(var i=0; i< this.pData.length;i++){
                var d = this.pData[i];
                h.push({
                    id: d.Id,
                    status: this.isAccept ? this.$ORDER_STATUS.ACCEPTED : this.$ORDER_STATUS.REJECTED,
                    reason: d.Dispatch_Status_Remarks,
                    ref_no: d.SAP_No + " / " + d.Order_No
                });
            }

            return h;
        }
    }
})
</script>
